$(document).ready(function() {
    $('.show_hide').hide();
    $("li:has(ul)").click(function() {
        $("ul", this).toggle('blind');
    });

    $("#sgNavbarLocaleMenuLink").click(function() {
        if($('.language_switchwer').hasClass('show')){
            $('.language_switchwer').removeClass('show');
        }else{
            $('.language_switchwer').addClass('show');
        }
    });


});
